/** Badge tone for status and labels. */
export type BadgeVariant = "neutral" | "success" | "warning";

/**
 * Small status pill for roster states and metadata.
 *
 * @param text - Visible label (catalog-backed).
 * @param variant - Colour token suffix; defaults to **`neutral`**.
 * @returns **`span`** with **`qz-badge`** classes.
 */
export function createBadge(
  text: string,
  variant: BadgeVariant = "neutral",
): HTMLSpanElement {
  const el = document.createElement("span");
  el.className = `qz-badge qz-badge--${variant}`;
  el.textContent = text;
  return el;
}
